import Slider from "react-slick";
import ArrowSvg from "../individual-components/arrow-svg";
import PropTypes from 'prop-types'

const TeamListCarousel = (props) => {

    const { currentSlide, setCurrentSlide, items } = props

    const DEFAULT_SETTINGS = {
        className: "center",
        focusOnSelect: true,
        centerMode: true,
        centerPadding: "20px",
        autoplay: true,
        autoplaySpeed: 5000,
    }

    const settings = {
        ...DEFAULT_SETTINGS,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    ...DEFAULT_SETTINGS
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    ...DEFAULT_SETTINGS
                }
            }
        ],
        initialSlide: 1,


        // prevArrow: <ArrowSvg direction='prev' />,
        // nextArrow: <ArrowSvg direction='next' />,
    };

    return (
        <div className="slider-container sm:mx-4">
            <Slider
                {...settings}
                infinite={false}
                lazyLoad="ondemand"
                arrows
                beforeChange={(cur, next) => setCurrentSlide(next)}
            >
                {items?.map((item, index) => (
                    <button
                        aria-label={item}
                        key={item + index + Math.random(123493)}
                        onClick={() => setCurrentSlide(index)}
                        className="w-full px-5 min-w-52 h-full my-auto cursor-pointer text-center">
                        <div
                            className={`${index !== currentSlide ? 'opacity-20 text-3xl mt-1' : 'opacity-100 text-4xl'} sm:text-2xl font-bold text-[#35343A]  px-1 transition-all`}>
                            {item}
                        </div>
                    </button>
                ))}
            </Slider>
        </div>
    );
}

TeamListCarousel.propTypes = {
    currentSlide: PropTypes.number,
    setCurrentSlide: PropTypes.func,
    items: PropTypes.array
}

export default TeamListCarousel